import React, { FC, useCallback, useEffect } from 'react';
import app from 'srcJs/App';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { StateType } from 'moduleBase/modules/menu-balance/types/StateType';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import { appUserLoadBalance } from 'moduleBase/actions/user-load-balance';
import { Response } from '@collaborator/npm_modules/dist/components/NetworkService';
import { UserLoadBalanceResponseType } from 'moduleBase/actions/types/UserLoadBalanceResponseType';
import { BalanceObserver } from 'moduleBase/components/observers/BalanceObserver';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import {
  MESSAGE_INVOICE_NOTIFY,
  MESSAGE_TYPE_PROJECT_CREATE,
  MESSAGE_TYPE_PROJECT_DELETE,
} from 'srcJs/components/realtime-notification/constants/constants';
import { userLoadData } from 'moduleUser/actions/load-data';
import { UserLoadDataResponseType } from 'moduleUser/actions/types/UserLoadDataResponseType';
import { ProjectDeleteType } from 'srcJs/components/realtime-notification/types/ProjectDeleteType';
import { ProjectCreateType } from 'srcJs/components/realtime-notification/types/ProjectCreateType';
import { menuBalanceLoad } from 'moduleBase/modules/menu-balance/actions/load';

type DispatchPropsType = {
  userLoadBalance: () => Promise<Response<UserLoadBalanceResponseType>>;
  loadData: () => Promise<Response<UserLoadDataResponseType>>;
  loadMenuBalance: () => void;
};

const UserObserver: FC<DispatchPropsType> = ({
  userLoadBalance,
  loadData,
  loadMenuBalance,
}) => {
  const loadBalance = useCallback(() => {
    userLoadBalance().then((response) => {
      app.getUser().setBalance(response.data.balance);
    });
  }, []);

  const loadDataWrapper = () => {
    loadData().then((response) => {
      app.getUser().setData(response.data.user);
    });
  };

  const handlerProjectCreate = useCallback((message: ProjectCreateType) => {
    if (!message.isFirst) {
      return;
    }

    loadDataWrapper();
  }, []);

  const handlerProjectDelete = useCallback((message: ProjectDeleteType) => {
    if (!message.isLast) {
      return;
    }

    loadDataWrapper();
  }, []);

  const handlerInvoiceNotify = useCallback(() => {
    loadDataWrapper();
    loadMenuBalance();
  }, []);

  useEffect(() => {
    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_CREATE, handlerProjectCreate);
    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_DELETE, handlerProjectDelete);
    realtimeNotification.addListener(MESSAGE_INVOICE_NOTIFY, handlerInvoiceNotify);

    return () => {
      realtimeNotification.removeListener(handlerProjectCreate);
      realtimeNotification.removeListener(handlerProjectDelete);
      realtimeNotification.removeListener(handlerInvoiceNotify);
    };
  }, []);

  return <BalanceObserver callback={loadBalance} />;
};

export default connect<StateType, DispatchPropsType>(UserObserver, {
  mapDispatchToProps: (dispatch) => (bindActionCreators<ActionCreatorsMapObject, DispatchPropsType>({
    userLoadBalance: appUserLoadBalance,
    loadData: userLoadData,
    loadMenuBalance: menuBalanceLoad,
  }, dispatch)),
});
